import React from 'react';


export const NLB = props => {
    return (
        <img className={props.className} src={require('../../../../resources/images/aws_icons/nlb.png')} />
    )
};
